import { FilterQueryStateCoder } from "models/propTypes/filterPropTypes";

const FilterQueryHelper = {
  // A view-only toggle (e.g. expand all rows) still round-trips through the URL, but must not make a link look like
  // a chosen filter: that is what decides whether the user's saved default filter gets applied on load.
  presentational<C extends FilterQueryStateCoder<any>>(coder: C): C {
    return { ...coder, presentational: true };
  },

  hasFilterPropsInQuery(
    filterQueryStateHandler: Record<string, FilterQueryStateCoder<any>>,
    searchParams: URLSearchParams
  ) {
    const filterProps = Object.keys(filterQueryStateHandler).filter((x) => !filterQueryStateHandler[x].presentational);
    return Array.from(searchParams.keys()).some((q) => {
      const formattedKey = q.replace(/^(\w+)(Start|End|Ids|Names)/, `$1`);
      return filterProps.some((x) => q === x || formattedKey === x);
    });
  },
};

export default FilterQueryHelper;
